import FeesCategoriesContainer from "../../container/admin/fees-categories";

const FeesCategories = () => {
    return <FeesCategoriesContainer />;
};

export default FeesCategories;